/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Constants for Poi module
 */

export const CLEAR_POI = '@@nzr/poi/CLEAR_POI' as const
export const DONE_FETCHING_POI = '@@nzr/poi/DONE_FETCHING_POI' as const
export const ERROR_FETCHING_POI = '@@nzr/poi/ERROR_FETCHING_POI' as const
export const RECEIVE_POI = '@@nzr/poi/RECEIVE_POI' as const
export const START_FETCHING_POI = '@@nzr/poi/START_FETCHING_POI' as const
